<template>
  <div v-if="tasks.length" class="align-middle">
    <div class="text-gray-700 text-sm task-text font-bold cursor-pointer" @click="$router.push({ name: 'tasks' })">
      <span v-if="upload_tasks_running" class="">
        正在上传[{{ upload_tasks_running }}]: {{ upload_speed }}
      </span>
      <span v-if="download_tasks_running" class="">
        正在下载[{{ download_tasks_running }}]: {{ download_speed }}
      </span>
      <span v-if="download_tasks_running" class="text-gray-500">
        (请勿关闭本页面)
      </span>
      <span v-if="finished_tasks" class="text-green-700">已完成：{{ finished_tasks }}</span>
      <span v-if="failed_tasks" class="text-red-700">失败：{{ failed_tasks }}</span>
    </div>
    <div class="ui teal tiny progress" id="task-indicator">
      <div class="bar">
        <div class="progress"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskIndicator',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    tasks() {
      return this.$store.state.tasks;
    },
    upload_tasks_total() {
      return this.tasks.filter(t => t.type == "upload").length;
    },
    upload_tasks_running() {
      return this.tasks.filter(t => t.type == "upload" && (t.running || t.created)).length;
    },
    download_tasks_total() {
      return this.tasks.filter(t => t.type == "download").length;
    },
    download_tasks_running() {
      return this.tasks.filter(t => t.type == "download" && (t.running || t.created)).length;
    },
    finished_tasks() {
      return this.tasks.filter(t => t.succeeded).length;
    },
    failed_tasks() {
      return this.tasks.filter(t => t.failed).length;
    },
    download_speed() {
      var bps = this.$store.getters.download_bps;
      return this.bytes_to_human(bps) + "/s";
    },
    upload_speed() {
      var bps = this.$store.getters.upload_bps;
      return this.bytes_to_human(bps) + "/s";
    },
  },
  methods: {
    update_progress_bar() {
      var per = this.$store.state.total_percent;
      this.$("#task-indicator").progress({
        percent: per,
        text: {
          percent: false,
        },
      });
    },
  },
  mounted() {
    setInterval(() => {
      this.update_progress_bar();
    }, 1000);
  },
}
</script>

<style scoped>
#task-indicator {
  margin-bottom: 0 !important;
}

.task-text > span {
  margin-right: 1rem;
}
</style>

